// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-physical-main[data-v-f4978160]{background-color:var(--color-white);border-radius:var(--border-radius-normal);display:flex;flex-direction:column}@media(min-width:1024px){.product-physical-main[data-v-f4978160]{border-bottom-left-radius:0;border-top-left-radius:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
